import { observer } from "mobx-react";
import myStore from "../mobX/Store";
import { Route, Routes, useLocation } from "react-router-dom";
import Navigations from "../Components/seo/Navigations";
import { useEffect, useState } from "react";

// Indeces
import EventosDeportivos from "../Components/seo/sports/EventosDeportivos";
import CuotasDeportivos from "../Components/seo/sports/CuotasDeportivas";

// Casino
import Casino from "../Components/seo/casino/Casino";
import Blackjack from "../Components/seo/casino/Blackjack";
import Slots from "../Components/seo/casino/Slots";
import Baccarat from "../Components/seo/casino/Baccarat";
import Bingo from "../Components/seo/casino/Bingo";
import Inicio from "../Components/Inicio";
import Jackpots from "../Components/seo/casino/Jackpots";
import Ruleta from "../Components/seo/casino/Ruleta";
import CasinoEnVivo from "../Components/seo/casino/CasinoEnVivo";
import InicioSegmented from "../Components/InicioSegmented";

// Eventos
import Mundial from "../Components/seo/sports/events/Mundial";
import Baloncesto from "../Components/seo/sports/events/Baloncesto";
import MLB from "../Components/seo/sports/events/MLB";
import Superbowl from "../Components/seo/sports/events/Superbowl";

// Coutas
import BaloncestoCoutas from "../Components/seo/sports/coutas/Baloncesto";
import Formula from "../Components/seo/sports/coutas/Formula";
import Football from "../Components/seo/sports/coutas/Futbol";
import Ciclismo from "../Components/seo/sports/coutas/Ciclismo";
import NFL from "../Components/seo/sports/coutas/NFL";
import Tenis from "../Components/seo/sports/coutas/Tenis";
import UFC from "../Components/seo/sports/coutas/UFC";

import useRoutes from "./useRoutes";
import Freebets from "../Components/seo/ayuda/Freebets";
import Freespins from "../Components/seo/ayuda/Freespins";
import Goldenchips from "../Components/seo/ayuda/Goldenchips";
const MyRouting = observer(() => {
  const location = useLocation();
  const [activated, setActivated] = useState(1);
  const [isCasinoPage, setCasinoPage] = useState(
    location.pathname.includes("casino")
  );
  const [navigateData, setNavigateData] = useState({ isFound: false, pos: -1 });
  const navigatePaths = ["eventos", "cuotas", "casino", "ayuda"];

  const initNavigationData = () => {
    const section = location.pathname.substring(1).split("/")[0].split("-")[0];
    setCasinoPage(section === "casino");

    const res = navigatePaths.find((sub, pos) => {
      const isFound = location.pathname.includes(sub);
      setNavigateData(isFound ? { isFound, pos } : { isFound: false, pos: -1 });
      return isFound;
    });

    return res;
  };

  useEffect(() => {
    initNavigationData();
    changeFavicon();
    setActivated(activeHandler);
    window.scrollTo(0, 0);
  }, [location.pathname]);

  useRoutes();

  function changeFavicon() {
    let fav = document.querySelector("link[rel='icon'");
    fav.parentNode.removeChild(fav);

    //
    const newFav = document.createElement("link");
    newFav.rel = "icon";
    newFav.href = `https://www.codere.com.co/assets/icons/favicon-${
      location.pathname.includes("casino") ? "casino" : "deportes"
    }.ico`;
    document.head.appendChild(newFav);
  }

  const activeHandler = () => {
    switch (location.pathname) {
      case "/casino":
      case "/eventos-deportivos/apuestas-mundial-fifa":
      case "/cuotas-deportivas/apuestas-baloncesto":
      case "/ayuda/free-bets":
        return 1;
      case "/casino/casino-en-vivo":
      case "/eventos-deportivos/apuestas-mundial-baloncesto":
      case "/cuotas-deportivas/apuestas-formula1":
      case "/ayuda/free-spins":
        return 2;
      case "/casino/slots":
      case "/eventos-deportivos/apuestas-juego-de-las-estrellas":
      case "/cuotas-deportivas/apuestas-futbol":
      case "/ayuda/golden-chips":
        return 3;
      case "/casino/blackjack":
      case "/eventos-deportivos/apuestas-superbowl":
      case "/cuotas-deportivas/apuestas-ciclismo":
        return 4;
      case "/casino/ruleta":
      case "/cuotas-deportivas/apuestas-nfl":
        return 5;
      case "/casino/jackpots":
      case "/cuotas-deportivas/apuestas-ufc":
        return 6;
      case "/casino/baccarat":
      case "/cuotas-deportivas/apuestas-tenis":
        return 7;
      case "/casino/video-bingo":
        return 8;
      default:
        return 0;
    }
  };

  return (
    <>
      {navigateData.isFound && (
        <Navigations
          index={activated}
          type={navigateData.pos}
          isCasinoPage={isCasinoPage}
        />
      )}
      <Routes>
        {!myStore.segmented ? (
          <Route exact path="/" element={<Inicio flag={myStore.flag} />} />
        ) : (
          <Route
            exact
            path="/"
            element={<InicioSegmented flag={myStore.flag} />}
          />
        )}
        <Route exact path="eventos-deportivos">
          <Route
            exact
            path=""
            element={<EventosDeportivos flag={myStore.flag} />}
          />
          <Route
            exact
            path="apuestas-mundial-fifa"
            element={<Mundial flag={myStore.flag} />}
          />
          <Route
            exact
            path="apuestas-mundial-baloncesto"
            element={<Baloncesto flag={myStore.flag} />}
          />
          <Route
            exact
            path="apuestas-juego-de-las-estrellas"
            element={<MLB flag={myStore.flag} />}
          />
          <Route
            exact
            path="apuestas-superbowl"
            element={<Superbowl flag={myStore.flag} />}
          />
        </Route>

        <Route exact path="cuotas-deportivas">
          <Route
            exact
            path=""
            element={<CuotasDeportivos flag={myStore.flag} />}
          />
          <Route
            exact
            path="apuestas-futbol"
            element={<Football flag={myStore.flag} />}
          />
          <Route
            exact
            path="apuestas-baloncesto"
            element={<BaloncestoCoutas flag={myStore.flag} />}
          />
          <Route
            exact
            path="apuestas-ciclismo"
            element={<Ciclismo flag={myStore.flag} />}
          />
          <Route
            exact
            path="apuestas-nfl"
            element={<NFL flag={myStore.flag} />}
          />
          <Route
            exact
            path="apuestas-superbowl"
            element={<Superbowl flag={myStore.flag} />}
          />
          <Route
            exact
            path="apuestas-formula1"
            element={<Formula flag={myStore.flag} />}
          />
          <Route
            exact
            path="apuestas-ufc"
            element={<UFC flag={myStore.flag} />}
          />
          <Route
            exact
            path="apuestas-tenis"
            element={<Tenis flag={myStore.flag} />}
          />
        </Route>
        {/*SEO Casino */}
        <Route exact path="casino">
          <Route exact path="" element={<Casino flag={myStore.flag} />} />
          <Route
            exact
            path="casino-en-vivo"
            element={<CasinoEnVivo flag={myStore.flag} />}
          />
          <Route
            exact
            path="blackjack"
            element={<Blackjack flag={myStore.flag} />}
          />
          <Route exact path="ruleta" element={<Ruleta flag={myStore.flag} />} />
          <Route exact path="slots" element={<Slots flag={myStore.flag} />} />
          <Route
            exact
            path="jackpots"
            element={<Jackpots flag={myStore.flag} />}
          />
          <Route
            exact
            path="baccarat"
            element={<Baccarat flag={myStore.flag} />}
          />
          <Route
            exact
            path="video-bingo"
            element={<Bingo flag={myStore.flag} />}
          />
        </Route>

        {/* Ayuda  */}
        <Route exact path="ayuda">
          <Route
            exact
            path="free-bets"
            element={<Freebets flag={myStore.flag} />}
          />
          <Route
            exact
            path="free-spins"
            element={<Freespins flag={myStore.flag} />}
          />
          <Route
            exact
            path="golden-chips"
            element={<Goldenchips flag={myStore.flag} />}
          />
        </Route>
      </Routes>
    </>
  );
});

export default MyRouting;
